import React, { useState } from 'react';

import {
  ISliderContextProps,
  ISliderProviderProps,
} from './SliderContext.types';

export const SliderContext = React.createContext<ISliderContextProps>({
  index: 0,
  setIndex: (): void => {
    return;
  },
  currentData: undefined,
  data: [],
  setData: (): void => {
    return;
  },
  hasNext: false,
  hasPrev: false,
});

export const SliderProvider = ({
  children,
  datas = [],
}: ISliderProviderProps): JSX.Element => {
  const [index, setIndex] = useState(0);
  const [data, setData] = useState(datas);
  const handleSetIndex = (newIndex: number) => {
    if (newIndex >= 0 && newIndex < data.length) {
      setIndex(newIndex);
    }
  };
  return (
    <SliderContext.Provider
      value={{
        index,
        setIndex: handleSetIndex,
        currentData: data[index],
        data,
        setData,
        hasNext: index >= 0 && index < data.length - 1,
        hasPrev: index > 0,
      }}
    >
      {children}
    </SliderContext.Provider>
  );
};

export const useSlider = (): ISliderContextProps => {
  const sliderProps = React.useContext(SliderContext);
  return sliderProps;
};
